import type { ShortCircuitSummary } from '.';
import type { CompletedCalculationTactic, VoltageLevel } from '../..';
import type { EvaluationRule } from '../../evaluation/EvaluationRule';
import { RulesProvider } from '../../evaluation/RulesProvider';
import { getLvShortCircuitSummary } from './lowVoltage/lvSummary';
import { getMvShortCircuitSummary } from './mediumVoltage/mvSummary';

export function getShortCircuitSummary(
  calculationTactic: CompletedCalculationTactic,
  evaluationRules: EvaluationRule[],
  voltageLevel: VoltageLevel
): ShortCircuitSummary {
  const shortCircuitResults =
    calculationTactic.calculationSetResult.calculationScenarios.shortCircuit;
  const functionalGrid = calculationTactic.calculationSetResult.grid.functional;
  const rulesProvider = RulesProvider.fromRules(evaluationRules);

  switch (voltageLevel) {
    case 'LowVoltage':
      return {
        value: getLvShortCircuitSummary(shortCircuitResults, rulesProvider),
        type: 'LowVoltage'
      };
    case 'MediumVoltage':
      return {
        value: getMvShortCircuitSummary(
          shortCircuitResults,
          rulesProvider,
          functionalGrid
        ),
        type: 'MediumVoltage'
      };
    default:
      throw new Error('Unknown voltage level');
  }
}
